/**
 * Shared shell sizing tokens.
 * Keep shell and workspace bounds centralized so the split controller and shell
 * both use the same explicit numbers.
 */
export interface ResizablePaneMetrics {
  readonly defaultWidth: number;
  readonly minWidth: number;
  readonly maxWidth: number;
}

export const LEFT_RAIL_WIDTH = 60;

export const LIST_PANE_METRICS: ResizablePaneMetrics = {
  defaultWidth: 368,
  minWidth: 300,
  maxWidth: 440,
};

export const AGENT_PANE_METRICS: ResizablePaneMetrics = {
  defaultWidth: 388,
  minWidth: 320,
  maxWidth: 460,
};

export const WORKSPACE_DETAIL_MIN_WIDTH = 560;
export const WORKSPACE_RESIZE_HANDLE_WIDTH = 1;

export const MODULE_LAYOUT_PANE_WIDTHS_STORAGE_KEY =
  "majordomo:workspace-pane-widths:v1";
